import axios from 'axios';
function createHandle(proxyfun, _axios) {
  return function () {
    const ops = proxyfun.apply(null, arguments)
    return _axios(ops)
  }
}

function getAxios(ops) {
  const instance = axios.create(ops.axiosOption)
  instance.interceptors.request.use(config => {
    if (ops.interceptors && ops.interceptors.request) {
      ops.interceptors.request(config)
    }
    return config
  })

  instance.interceptors.response.use(
    response => {
      if (ops.interceptors && ops.interceptors.response) {
        ops.interceptors.response(response)
      }
      let result = {
        status: response.status,
        statusText: response.statusText,
        data: response.data
      }
      if (ops.successHandle) {
        try {
          var promiseHandle = ops.successHandle(result.data, response)
          if (promiseHandle) {
            return promiseHandle
          }
        } catch (error) {
          return Promise.resolve(result.data)
        }
      } else {
        return Promise.resolve(result.data)
      }
    },
    function (error) {
      //自定义错误处理机制
      if (ops.errorHandle) {
        try {
          var promiseHandle = ops.errorHandle(error)
          if (promiseHandle) {
            return promiseHandle
          }
        } catch (error) {
          return Promise.reject(error)
        }
      } else {
        return Promise.reject(error)
      }
    }
  )
  return instance
}

export default function request(options, api) {
  const _axios = getAxios(options)
  let http = {}
  for (let k in api) {
    const v = api[k]
    let fObj = {}
    for (let f in v) {
      fObj[f] = createHandle(api[k][f], _axios)
    }
    http[k] = fObj
  }
  return { http, request: _axios }
}

